import { render, staticRenderFns } from "./PossessionCompanionFaqDropdown.vue?vue&type=template&id=05954e96"
import script from "./PossessionCompanionFaqDropdown.vue?vue&type=script&lang=ts"
export * from "./PossessionCompanionFaqDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports